import { combineReducers } from 'redux';
import { segmentsReducer } from './segments/reducers';
export var rootReducer = combineReducers({
    segments: segmentsReducer
});
